export const anchorIds = {
  backToTop: 'back-to-top',
};
